import httpService from '@/utils/request'
import { contextPath } from '@/config/'
export const querySpiderClassInfoApi = (params) => {
  return httpService({
    url: contextPath + '/spider/class/info',
    method: 'get',
    params
  })
}

export const addSpiderClassItemApi = (data) => {
  return httpService({
    url: contextPath + '/spider/class/item',
    method: 'post',
    data
  })
}

export const deleteSpiderClassItemApi = (params) => {
  return httpService({
    url: contextPath + '/spider/class/item',
    method: 'delete',
    params
  })
}

export const updateSpiderClassItemApi = (data) => {
  return httpService({
    url: contextPath + '/spider/class/item',
    method: 'put',
    data
  })
}
